const reportTypeOptionMapper = {
    // 일별 매출 / 배달대행료 B2B
    B2B_DELIVERY_CHARGE: 'b2bDeliveryCharge',
    // 일별 매출 / 배달대행료 로드샵(본사계약)
    ROAD_SHOP_DELIVERY_CHARGE: 'roadShopDeliveryCharge',
    // 일별 매출 / 배달대행료 / 상세 정보 B2B
    B2B_DELIVERY_CHARGE_DETAIL: 'b2bDeliveryChargeDetail',
    // 일별 매출 / 배달대행료 / 상세 정보 로드샵
    ROAD_SHOP_DELIVERY_CHARGE_DETAIL: 'roadShopDeliveryChargeDetail',
    // 일별 매출 / 상점 수수료
    STORE_FEE: 'storeFee',
    // 일별 매출 / 상점 수수료 / 상세 정보
    STORE_FEE_DETAIL: 'storeFeeDetail',
    // 일별 매출 / 상점 관리비
    STORE_MANAGEMENT_FEE: 'storeManagementFee',
    // 일별 매출 / 허브 수수료 발주총판 수익
    SALES_ORDER_DISTRIBUTOR_HUB_FEE: 'salesOrderDistributorHubFee',
    // 매입 / 허브
    PURCHASE_HUB_FEE: 'purchaseHubFee',
    // 매입 / 상점
    PURCHASE_STORE_MANAGEMENT_FEE: 'purchaseStoreManagementFee',
};
export { reportTypeOptionMapper, };
